import css from 'styled-jsx/css';

const staticStyles = css`
  .ApproveWithdrawalForm {
    margin-top: 30px;

    &__btns {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 15px;

      :global(.DefaultButton) {
        margin: 0;
      }

      :global(.ApproveWithdrawalForm__group-approve) {
        min-width: 220px;
        padding: 13px 30px;
        font-size: 17px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.18);
      }
    }
  }
`;

export default staticStyles;
